import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wc-product-badges"
}
const _hoisted_2 = { class: "wc-badge__label" }

import { inject, computed } from 'vue';
import { PRODUCT_AVAILABILITY_STATUS } from '@/constants/AppConstants';
import { configurationKey } from '@/injections';
import {
  PROMO_RIBBON_TYPE,
  RIBBON_CONFIG_MODERN,
} from '../../constants/PromoRibbonConstantsModern';
// ..
const MAX_BADGES = 2;


export default /*@__PURE__*/_defineComponent({
  __name: 'WCProductCardBadgesModern',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const BADGE_PRIORITY = {
  OUT_OF_STOCK: 1,
  SHOW_QUANTITY: 2,
  LOW_STOCK: 3,
  AUTO_DISCOUNT: 4,
  SALE: 5,
};

const props = __props;

const configuration = inject(configurationKey);

const discountConfig = RIBBON_CONFIG_MODERN[PROMO_RIBBON_TYPE.DISCOUNT_NAME_RIBBON];
const saleConfig = RIBBON_CONFIG_MODERN[PROMO_RIBBON_TYPE.SALE_AMOUNT_RIBBON];

const displayBadges = computed(() => {
  const product = props.product;
  const discountCanDisplay = discountConfig.canDisplay(product);
  const saleCanDisplay = saleConfig.canDisplay(product);
  return [
    {
      key: 'out',
      priority: BADGE_PRIORITY.OUT_OF_STOCK,
      class: 'wc-badge--out-of-stock',
      dotColor: 'danger',
      label: configuration?.outOfStockTerm ?? '',
      canDisplay: product.availability === PRODUCT_AVAILABILITY_STATUS.out,
    },
    {
      key: 'showQuantity',
      priority: BADGE_PRIORITY.SHOW_QUANTITY,
      class: 'wc-badge--show-quantity',
      dotColor: 'warning-light',
      label: `${product.onHand} ${configuration?.inStockTerm ?? ''}`,
      canDisplay: product.availability === PRODUCT_AVAILABILITY_STATUS.showQuantity,
    },
    {
      key: 'low',
      priority: BADGE_PRIORITY.LOW_STOCK,
      class: 'wc-badge--low-stock',
      dotColor: 'warning-light',
      label: configuration?.limitedAvailabilityTerm ?? '',
      canDisplay: product.availability === PRODUCT_AVAILABILITY_STATUS.low,
    },
    {
      key: 'autoDiscount',
      priority: BADGE_PRIORITY.AUTO_DISCOUNT,
      class: 'wc-badge--discount',
      dotColor: 'warning-dark',
      label: discountCanDisplay ? discountConfig.getTextContent(product) : '',
      canDisplay: discountCanDisplay,
    },
    {
      key: 'sale',
      canDisplay: saleCanDisplay,
      priority: BADGE_PRIORITY.SALE,
      class: 'wc-badge--sale',
      dotColor: 'success-dark',
      label: saleCanDisplay ? saleConfig.getTextContent(product) : '',
    },
  ]
    .filter(badge => badge.canDisplay)
    .sort((a, b) => a.priority - b.priority)
    .slice(0, MAX_BADGES);
});

return (_ctx: any,_cache: any) => {
  return (displayBadges.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayBadges.value, (badge) => {
          return (_openBlock(), _createElementBlock("span", {
            key: badge.key,
            class: _normalizeClass(["wc-badge", badge.class])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["wc-badge__dot", `wc-badge__dot--${badge.dotColor}`])
            }, null, 2),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _createElementVNode("span", _hoisted_2, _toDisplayString(badge.label), 1)
          ], 2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})